import actionTypes from './actionTypes';
import { createReducer } from '../../util/createReducer';

export interface MaskedModeState {
  active: boolean;
}

const INITIAL_STATE: MaskedModeState = {
  active: localStorage.getItem('maskedMode') !== 'false',
};

const reducer = createReducer(INITIAL_STATE, {
  [actionTypes.SET_MASKED_MODE]: (state, action) => {
    localStorage.setItem('maskedMode', action.active.toString());
    return { ...state, active: action.active };
  },
});

export default reducer;
